export default __webpack_public_path__ + "static/media/logo.606790e7.svg";